import store from '../store'
import Web3 from 'web3'
// 假设你要收取以太币消费
const yourAddress = '0x0c54FcCd2e384b4BB6f2E405Bf5Cbc15a017AaFb'
const value = '0xde0b6b3a7640000' // 16进制表示的以太币数量，单位：wei
// const desiredNetwork = '1' // '1' 表示以太坊主网
/*
 * MetaMask钱包对象
 * MetaMask 将全局 API 注入其用户访问的网站window.ethereum。该 API 允许网站请求用户的以太坊账户，从用户连接的区块链读取数据，并建议用户签署消息和交易。提供者对象的存在表明以太坊用户。我们建议使用@metamask/detect-provider （打开新窗口）在任何平台或浏览器上检测我们的提供商
 */
const metaMask = {
  // 初始化并获取账号
  init() {
    return new Promise((resolve, reject) => {
      //检测当前浏览器是否以太坊兼容，并进行相应的处理
      if (typeof window.ethereum === 'undefined') {
        reject(new Error('Consider installing MetaMask!'));
      } else {
        //如果用户安装了MetaMask，你可以要求他们授权应用登录并获取其账号
        window.ethereum.request({method: 'eth_requestAccounts'})
          //如果用户拒绝了登录请求
          .catch(reason => {
            store.commit("SET_WALLET_CONNECT", false)
            if (reason === 'User rejected provider access') {
              // 用户不想登录，你看该怎么办？
              reject(new Error('用户不想登录，你看该怎么办'));
            } else {
              // 本不该执行到这里，但是真到这里了，说明发生了意外
              reject(new Error('说明发生了意外'));
            }
          })
          //如果用户同意了登录请求，你就可以拿到用户的账号
          .then(accounts => {
            //一旦获取了用户账号，你就可以签名交易
            this.initEvent()
            store.commit("SET_WALLET_CONNECT", true)
            store.commit("SET_WALLET_ACCOUNT", accounts[0])
            localStorage.setItem("addres",accounts[0])
            resolve(accounts)
          })
      }
    })
  },
  // 监控改变事件
  async initEvent() {
    // 帐户更改事件
    window.ethereum.on('accountsChanged', (accounts) => {
      // 如果返回数组中的第一个帐户不是您期望的帐户，您应该通知用户！将来，accounts 数组可能包含多个帐户。但是，数组中的第一个帐户将继续被视为用户的“选定”帐户。
      console.log(accounts)
      store.commit("SET_WALLET_ACCOUNT", accounts[0])
      window.location.reload()
    })
    // 链改变事件
    window.ethereum.on('chainChanged', (chainId) => {
      console.log(chainId)
      store.commit("SET_WALLET_CHAIN_ID", chainId)
      window.location.reload();
    })
    // MetaMask 提供者收到一些应该通知消费者的消息事件
    window.ethereum.on('message', (message) => {
      // 消息类型：ProviderMessage
      // ProviderMessage {
      //   type: string;
      //   data: unknown;
      // }
      console.log(message)
    })
  },
  async initWeb3() {
    let self = this
    await self.init();
    return self.getWeb3();
  },
  async initContract(abis) {
    let self = this
    await self.init();
    let web3 = await self.getWeb3();
    console.log('web3js:', web3)
    return self.getContract(web3, abis)
  },
  getWeb3() {
    // 初始化web3
    if (window.ethereum) {
      let web3 = new Web3(window.ethereum);
      store.commit('SET_WALLET_WEB3', web3);
      return web3;
    }
    return null;
  },
  async getContract(web3, abis) {
    if (web3 && abis) {
      Object.keys(abis).forEach(key => {
        let contract = new web3.eth.Contract(abis[key].abi, abis[key].address, {
          from: store.state.wallet.account,
          value: 0,
          gas: 600000,
          gaslimit: 10
        })
        store.commit('SET_WALLET_CONTRACT', {key: key, contract: contract})
      })
    }
  },
  // 获取网络。1：以太坊主网； 2：Morden测试链； 3：Ropsten测试链； 4：Rinkeby测试链； 5：歌尔力测试网； 42：Kovan测试链
  getNetworkVersion() {
    if (!window.ethereum) return undefined;
    return window.ethereum.request({method: 'net_version'})
  },
  // 获取链ID。0x1：以太坊主网； 0x2：Morden测试链； 0x3：Ropsten测试链； 0x4：Rinkeby测试链； 0x5：歌尔力测试网； 0x2a：Kovan测试链
  getChainId() {
    if (!window.ethereum) return undefined;
    return window.ethereum.request({method: 'eth_chainId'});
  },
  // 获取当前账户
  getAccounts() {
    if (!window.ethereum) return undefined;
    return window.ethereum.request({method: 'eth_accounts'});
  }
}
export const sendEtherFrom = (account, callback) => {
  // 在这里我们要使用底层API
  const method = 'eth_sendTransaction'
  const parameters = [{
    from: account,
    to: yourAddress,
    value: value,
  }]
  const from = account
  // 现在把所有数据整合为一个RPC请求
  const payload = {
    method: method,
    params: parameters,
    from: from,
  }
  //需要用户授权的方法，类似于这个，都会弹出一个对话框提醒用户交互
  //其他方法，例如只是读取区块链的数据，可能就不会弹框提醒
  window.ethereum.sendAsync(payload, function(err, response) {
    const rejected = 'User denied transaction signature.'
    if (response.error && response.error.message.includes(rejected)) {
      return alert(`We can't take your money without your permission.`)
    }
    if (err) {
      return alert('There was an issue, please try again.')
    }
    if (response.result) {
      //如果存在response.result，那么调用就是成功的
      //在这种情况下，它就是交易哈希
      const txHash = response.result
      alert('Thank you for your generosity!')
      //你可以轮询区块链来查看交易何时被打包进区块
      this.pollForCompletion(txHash, callback)
    }
  })
}
export const pollForCompletion = (txHash, callback) => {
  let calledBack = false
  //正常情况下，以太坊区块大约15秒钟出一块
  //这里我们每隔2秒钟轮询一次
  const checkInterval = setInterval(function() {
    const notYet = 'response has no error or result'
    window.ethereum.sendAsync({
      method: 'eth_getTransactionByHash',
      params: [txHash],
    }, function(err, response) {
      if (calledBack) return
      if (err || response.error) {
        if (err.message.includes(notYet)) {
          return 'transaction is not yet mined'
        }
        callback(err || response.error)
      }
      //我们已经成功地验证了打包入块的交易
      //提醒一下，我们应当在服务端使用我们的区块链连接进行验证
      //在客户端做的话，就意味着我们信任用户的区块链连接
      const transaction = response.result
      clearInterval(checkInterval)
      calledBack = true
      callback(null, transaction)
    })
  }, 2000)
}
const install = Vue => {
  if (install.installedToast) {
    return
  }
  install.installedToast = true
  Object.defineProperties(Vue.prototype, {
    $metaMask: {
      get() {
        return metaMask
      }
    }
  })
}
export default install
